import { dashboardAuthUrl, fetchAuthJson } from './authBase';

const TOKEN_KEY = 'dashboard_auth_token';

export async function dashboardApi(path, options = {}) {
  const token = sessionStorage.getItem(TOKEN_KEY);
  const headers = {
    ...(options.headers || {}),
    Authorization: `Bearer ${token}`,
  };
  if (options.body && typeof options.body === 'string') {
    headers['Content-Type'] = 'application/json';
  }
  const res = await fetch(dashboardAuthUrl(path), { ...options, headers });
  return fetchAuthJson(res);
}
